import { mapActions } from 'vuex';
import Events from '_utils/events';
import WordService from '_services/rest/modules/word';

export default {
  name: 'word-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      WordService.deleteWord(this.selectWord)
        .then(() => {
          this.close();
          this.$router.push({ name: 'admin-word-list', params: { page: 1 } });
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Palavra deletada com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
